import kebabCase from 'lodash/kebabCase';
import type { CSSProperties, JSX } from 'react';
import { cn } from '../../v2';
import { CheckboxInput } from '../checkbox-input';
interface Props {
  className?: string;
  count?: number;
  disabled?: boolean;
  disabledLabelClassName?: string;
  id?: string;
  isActive?: boolean;
  label: string;
  labelClassName?: string;
  onClick?: (isActive: boolean) => unknown;
  /**
   * @deprecated Use className instead
   */
  style?: CSSProperties;
  testId?: string;
}
export function CheckboxRow({
  className,
  count,
  disabled,
  disabledLabelClassName,
  id,
  isActive,
  label,
  labelClassName,
  onClick,
  style = {},
  testId: propTestId
}: Props): JSX.Element {
  const testId = propTestId ?? id ?? kebabCase(label);
  return <div className={cn('flex', className)} style={style}>
      <CheckboxInput id={id} testId={testId} checked={isActive} onChange={e => {
      onClick?.(e.target.checked);
    }} disabled={disabled} />
      <div className="pr-1 pl-2">
        <label htmlFor={id}>
          <span className={cn('cursor-pointer text-base', labelClassName, {
          [disabledLabelClassName ?? '']: disabled
        })}>
            {label}
          </span>
        </label>
      </div>
      {count ? <span className="text-steel-300 text-base">({count})</span> : null}
    </div>;
}